import React from 'react';
import { Close } from '@10d/tend-ui-icons/Close';
import { useTheme } from '@10d/tend-ui-theme';
import { Tooltip } from '../../../Tooltip/Tooltip.js';
import { useDrawerContext } from '../../contexts/DrawerContext.js';
import { Root } from './styled.js';

const CloseButton = (props) => {
    const theme = useTheme();
    const context = useDrawerContext();
    return (React.createElement(Tooltip, { title: '\u0417\u0430\u043A\u0440\u044B\u0442\u044C' },
        React.createElement(Root, Object.assign({ onClick: context === null || context === void 0 ? void 0 : context.onClose }, props, { theme: theme }),
            React.createElement(Close, { size: 20 }))));
};
CloseButton.displayName = 'Drawer.CloseButton';

export { CloseButton };
